var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeosBik(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "url(#paint0_linear_5353_41049)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 32H8V16L20 8L32 16V32Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5353_41049",
    x1: 0,
    y1: 0,
    x2: 40,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0666667,
    stopColor: "#00CBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133333,
    stopColor: "#00CACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00C6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266667,
    stopColor: "#00C2CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#00BCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00B5CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466667,
    stopColor: "#00AECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533333,
    stopColor: "#00A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#009FCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#0098CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733333,
    stopColor: "#0092CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#008ECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866667,
    stopColor: "#008ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933333,
    stopColor: "#0089CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088CC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeosBik);
export default __webpack_public_path__ + "static/media/geosBik.d7b6f72531a048d56e0655f0f775debd.svg";
export { ForwardRef as ReactComponent };